import {
    Activity,
    BrainCircuit,
    Calendar,
    Compass,
    HeartHandshake,
    Layers,
    Rocket,
    ShieldAlert,
    ShieldCheck,
    Sparkles,
    Target,
    TrendingUp,
    UserPlus,
    Wallet,
} from "lucide-react";

const ICONS = {
    Activity,
    BrainCircuit,
    Calendar,
    Compass,
    HeartHandshake,
    Layers,
    Rocket,
    ShieldAlert,
    ShieldCheck,
    Sparkles,
    Target,
    TrendingUp,
    UserPlus,
    Wallet,
};

export function resolveCmsIcon(name, fallback = Sparkles) {
    if (!name || typeof name !== "string") return fallback;
    return ICONS[name] || fallback;
}

export function hydrateUseCase(item) {
    return {
        ...item,
        icon: resolveCmsIcon(item.icon),
    };
}

export function hydrateCaseStudy(item) {
    const displayId = item.isSignature ? "✦" : item.id;
    return {
        ...item,
        id: displayId,
        icon: resolveCmsIcon(item.icon),
        before: item.before ?? [],
        after: item.after ?? [],
    };
}
